/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import PropTypes from "prop-types";

import { Storage } from "../../lib/firebase";

// toast
import "react-toastify/dist/ReactToastify.css";

// components
import { AppContext } from "components";
import { BaseComponent } from "shared/components";
import AddPicturesComponent from "./AddPicturesComponent";
import AddBarcodesComponent from "./AddBarcodesComponent";

// controllers
import { SwipeGameController } from "controllers";

const DEFAULT_TABS = ['Barcodes', 'Pictures'];

class SwipeGameComponent extends BaseComponent {
    constructor(props) {
        super(props);
        this.productsRef = React.createRef();
        this.picturesRef = React.createRef();

        this.state = {
            theme: "",
            loading: false,
            count: 0,
            activeTab: DEFAULT_TABS[0]
        };
        this.reload = this.reload.bind(this);
        this.getURL = this.getURL.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
    }

    componentDidMount = async () => {
        this.useToast();
        document.addEventListener("keypress", function (e) {
            if (e.target.tagName !== "INPUT") {
                var input = document.querySelector("#barcode");
                input.focus();
                input.value = e.key;
                e.preventDefault();
            }
        });
        let { count } = this.state;
        count = await SwipeGameController.getLastImageID();
        this.setState({ count });
        // set active tab
        const search = this.props.location.search;
        const tab = new URLSearchParams(search).get('tab');

        if (tab) {
            const activeTab = DEFAULT_TABS.find((t) => t.toLowerCase() === tab.toLowerCase());
            this.setState({ activeTab });
        }
    };

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
        const pathname = this.props.history.location.pathname;
        this.props.history.push({
            pathname,
            search: `?tab=${tab.toLowerCase()}`
        })
    }

    reload = async () => {
        const { activeTab } = this.state;
        activeTab === 'Barcodes' ? await this.productsRef.current.reloadRef() : await this.picturesRef.current.reloadRef();
        await this.setState({ theme: "" });
    };

    valuesEmpty(values) {
        if (values.length === 0) {
            this.showErrorToast(`Please upload fill the fields and press on Add!`);
            return false;
        }

    }
    getURL = async (file) => {
        const stringData = file.base64.split(",");
        await Storage.ref(`swipe/${file.name}`).putString(
            stringData[1],
            "base64"
        );


        let url = await Storage.ref(`swipe`)
            .child(file.name)
            .getDownloadURL();
        return url;
    };


    addClicked = async () => {
        let { theme, count, activeTab } = this.state;
        if (!theme) {
            this.showErrorToast("Please enter a theme!");
            return;
        }
        const payload = [];
        if (activeTab === 'Pictures') {
            const picturesParent = this.picturesRef.current.getPictures();
            if (this.valuesEmpty(picturesParent) === false) { return };
            this.setState({ loading: true });
            this.context.showLoading();
            for (const picture of picturesParent) {
                count += 1;
                const newPicture = {
                    tags: picture.tags,
                    attributes: picture.attributes,
                    url: await this.getURL(picture.image),
                    cuts: picture.cuts,
                    details: picture.details,
                    theme: theme,
                    id: count,
                }
                payload.push(newPicture);
            }
        } else {
            const productsParent = this.productsRef.current.getProducts();
            if (this.valuesEmpty(productsParent) === false) { return };
            this.setState({ loading: true });
            this.context.showLoading();
            for (const product of productsParent) {
                count += 1;
                const newProduct = {
                    barcode: product.barcode,
                    tags: product.tags,
                    attributes: product.attributes,
                    url: product.imageURLs[0],
                    cuts: product.cuts,
                    theme: theme,
                    id: count,
                }
                payload.push(newProduct);
            }
        }
        try {
            const newLastID = payload[payload.length - 1].id;
            await SwipeGameController.setDeck(payload, newLastID);
            SwipeGameController.configThemeSwipeGame(theme);
            this.setState({ count: newLastID });
            this.showSuccessToast("Success!");
            await this.reload();
        } catch (error) {
            this.showErrorToast(error.message);
        }
        this.context.hideLoading();
        this.setState({
            loading: false
        });
    };

    handleChange(event) {
        const theme = event.target.value;
        this.setState({ theme });
    }

    render() {
        const { theme, activeTab } = this.state;
        let view = <AddBarcodesComponent ref={this.productsRef} />;
        if (activeTab === 'Pictures') {
            view = <AddPicturesComponent ref={this.picturesRef} />;
        }

        return (
            <div className="columns is-gapless">
                <div className="column is-1 is-hidden-mobile">
                    <section className="hero is-fullheight hero-swipe-game-pattern">
                        <div className="hero-body"></div>
                    </section>
                </div>
                <div className="container">
                    <nav className="level is-mobile">
                        <div className="level-left"></div>
                        <div className="level-right">
                            <div className="tabs is-large">
                                <ul>
                                    {(DEFAULT_TABS.map((tab) => (
                                        <li key={tab} className={tab === activeTab ? 'is-active' : ''}>
                                            <a onClick={() => this.setActiveTab(tab)}>{tab}</a>
                                        </li>
                                    )))}
                                </ul>
                            </div>
                        </div>
                    </nav>
                    <div className="column">
                        <div className="field">
                            <input
                                className="input"
                                onChange={(event) => this.handleChange(event)}
                                placeholder="Enter the theme here"
                                value={theme}
                                id="theme"
                            ></input>
                        </div>
                        <div>
                            {view}
                        </div>
                        <div className="field mt-3 ">
                            <p className="control">
                                <button
                                    className="button is-primary is-fullwidth"
                                    id="submit"
                                    onClick={() => this.addClicked()}
                                >
                                    Upload
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

SwipeGameComponent.contextType = AppContext;

SwipeGameComponent.propTypes = {
    history: PropTypes.object
};

export default SwipeGameComponent;
